"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArowBack = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArowBack"));

// Generated by script, don't edit it please.
var ArowBack = (0, _createSvgIcon["default"])({
  as: _ArowBack["default"],
  ariaLabel: 'arow back',
  category: 'direction',
  displayName: 'ArowBack'
});
var _default = ArowBack;
exports["default"] = _default;
module.exports = exports.default;